import { render, staticRenderFns } from "./PacksPayment.vue?vue&type=template&id=19cdae47&scoped=true&"
import script from "./PacksPayment.vue?vue&type=script&lang=js&"
export * from "./PacksPayment.vue?vue&type=script&lang=js&"
import style0 from "./PacksPayment.vue?vue&type=style&index=0&id=19cdae47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdae47",
  null
  
)

export default component.exports